var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"transition-colors font-medium inline-block",class:{
    'text-gray-900 bg-gray-100 hover:bg-gray-200': !_vm.disabled && _vm.color === 'gray',
    'text-white bg-sky-600 hover:bg-sky-200': !_vm.disabled && _vm.color === 'blue',
    'text-gray-400 bg-gray-50 hover:bg-gray-100': _vm.disabled && _vm.color === 'gray',
    'text-white bg-sky-300 hover:bg-sky-200': _vm.disabled && _vm.color === 'blue',
    'px-2': _vm.size === 'sm',
    'py-2 px-3': _vm.size === 'md',
    'py-3 px-3': _vm.size === 'lg'
  },attrs:{"disabled":_vm.disabled},on:{"click":function($event){return _vm.onClick()}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }